import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { useReveal } from "../hooks/useReveal";

const faqs = [
  {
    q: "Ile trwa realizacja strony?",
    a: "Strony one-page przeważnie do tygodnia od akceptacji projektu. Sklepy i większe, rozbudowane projekty od 3 tygodni wzwyż — wszystko zależy od zakresu i tempa Twoich decyzji. Konkretny termin ustalamy zawsze po krótkiej rozmowie i analizie.",
  },
  {
    q: "Ile kosztuje strona?",
    a: "Start od 1000 zł za stronę one-page. Sklepy internetowe i bardziej rozbudowane projekty wyceniamy indywidualnie po krótkiej rozmowie — wycena jest zawsze darmowa i bez zobowiązań. Ceny u nas są wyraźnie niższe niż u dużych agencji, a jakość ta sama (lub wyższa).",
  },
  {
    q: "Czy oferujecie hosting?",
    a: "Tak — proponujemy własny, szybki i niezawodny hosting dla naszych klientów. W ramach opieki dbamy o stronę, aktualizujemy szczegóły (np. ceny w cenniku, godziny otwarcia, treści), pilnujemy aktualizacji technicznych. Jak coś się dzieje ze stroną — jesteśmy. Klient nie zostaje sam z problemem, nawet po wdrożeniu.",
  },
  {
    q: "Czy zajmujecie się pozycjonowaniem (SEO)?",
    a: "Tak. Każdą stronę robimy zgodnie z dobrymi praktykami SEO już na etapie budowy (struktura, szybkość, treść, dane lokalne). Dodatkowo prowadzimy długofalowe pozycjonowanie — optymalizację, blog, link building i SEO lokalne — dla klientów, którzy chcą stale rosnąć w Google.",
  },
  {
    q: "Czy strona będzie dobrze działać na telefonie?",
    a: "Każdą stronę projektujemy i kodujemy mobile-first. Testujemy na realnych urządzeniach (iOS, Android), różnych rozmiarach ekranu, w różnych przeglądarkach. Strona ma być szybka, czytelna i wygodna w obsłudze — niezależnie od tego, czy klient otwiera ją na iPhonie, na tablecie, czy na laptopie.",
  },
];

export const FAQ = () => {
  const ref = useReveal();
  return (
    <section
      id="faq"
      ref={ref}
      data-testid="faq-section"
      className="relative py-24 md:py-32 px-6 md:px-10"
    >
      <div className="max-w-4xl mx-auto">
        <div className="reveal text-center mb-12">
          <span className="text-xs tracking-[0.2em] uppercase text-stormly-cyan font-bold">
            FAQ
          </span>
          <h2 className="font-heading font-bold text-4xl sm:text-5xl md:text-6xl mt-4 leading-[1.05]">
            Pytania, które zawsze padają.
          </h2>
        </div>

        <div className="reveal reveal-delay-1">
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="bg-[#1F1F38] border border-white/10 rounded-2xl px-6 data-[state=open]:border-stormly-cyan/30 transition-colors"
              >
                <AccordionTrigger className="text-left font-heading text-lg md:text-xl font-semibold hover:no-underline py-5 text-white">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-white/65 text-base leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
